export default "__VITE_ASSET__QuQFd0r$__"